<div class="row fs-6">
  <div class="col-2">
    <div class="centering-container details-text">
      <h6 style="display: inline-block;">Status: </h6>
    </div>
  </div>
  @if (!updating) {
    <div class="col-10">
      @if (mapEntity?.getIsPending()) {
        <div>
          <div class="col-md-12">
            <button type="button" class="btn btn-info" >
              Pending
              <i class="fa fa-clock-o" aria-hidden="true"></i>
            </button>
            @if (showButtons) {
              <div style="float: right;">
                <button type="button" class="btn btn-primary" (click)="approveUpdate()">
                  Approve
                  <i class="fa fa-pending" aria-hidden="true"></i>
                </button>
                <button type="button" class="btn btn-danger" style="margin-left: 10px;" (click)="rejectUpdate()">
                  Reject
                  <i class="fa fa-thumbs-down" aria-hidden="true"></i>
                </button>
              </div>
            }
          </div>
        </div>
      }
      @if (mapEntity?.getIsApproved()) {
        <div>
          <div class="col-md-10">
            <span class="label label-primary" style="padding: 8px 12px; font-size: 14px; display: inline-block; vertical-align: middle; line-height: 1.42857143;">Approved</span>
            @if (showButtons) {
              <div style="float: right;">
                <button type="button" class="btn btn-danger" style="margin-left: 10px;" (click)="rejectUpdate()">
                  Reject
                  <i class="fa fa-thumbs-down" aria-hidden="true"></i>
                </button>
              </div>
            }
          </div>
        </div>
      }
      @if (mapEntity?.getIsRejected()) {
        <div>
          <div class="col-md-10">
            <span class="label text-white label-danger" style="padding: 8px 12px; font-size: 14px; display: inline-block; vertical-align: middle; line-height: 1.42857143;">Rejected</span>
          </div>
        </div>
      }
    </div>
  }
  @if (updating) {
    <div class="col-md-10">
      <!-- <app-wave-spinner></app-wave-spinner> -->
    </div>
  }
</div>
<br>
  <div class="row fs-6">
    <div class="col-md-2">
      <div class="centering-container details-text">
        <h6 style="display: inline-block;">Visibility: </h6>
      </div>
    </div>
    <div class="col-md-10">
      @if (!updatingVisibility) {
        <div>
          @if (mapEntity?.getIsPublic()) {
            <div>
              @if (showButtons) {
                <div style="display: inline-block;">
                  <button type="button" class="btn btn-primary" (click)="makePrivate()">
                    Public
                    <i class="fa fa-toggle-on" aria-hidden="true"></i>
                  </button>
                </div>
              }
              @if (!showButtons) {
                <div style="display: inline-block;">
                  <span class="label label-primary" style="padding: 8px 12px; font-size: 14px; display: inline-block; vertical-align: middle; line-height: 1.42857143;">Public</span>
                </div>
              }
            </div>
          }
          @if (mapEntity?.getIsPrivate()) {
            <div>
              @if (showButtons) {
                <div style="display: inline-block;">
                  <button type="button" class="btn btn-primary" (click)="makePublic()">
                    Private
                    <i class="fa fa-toggle-off" aria-hidden="true"></i>
                  </button>
                </div>
              }
              @if (!showButtons) {
                <div style="display: inline-block;">
                  <span class="label label-primary" style="padding: 8px 12px; font-size: 14px; display: inline-block; vertical-align: middle; line-height: 1.42857143;">Private</span>
                </div>
              }
            </div>
          }
        </div>
      }
      @if (updatingVisibility) {
        <div>
          <div class="col-md-10">
            <!-- <app-wave-spinner></app-wave-spinner> -->
          </div>
        </div>
      }
    </div>
  </div>
  <br>